<template>
  <v-layout
    justify-center
    wrap
  >
    <v-flex
      v-if="moduleLicenses && moduleLicenses.data.length > 0"
      md12
    >
      <v-card>
        <v-data-table
          class="text-no-wrap"
          :headers="headers"
          :items="moduleLicenses.data"
          :server-items-length="moduleLicenses.total"
          :items-per-page="params.count"
          :page="params.page"
          :mobile-breakpoint="900"
          @update:options="loadLicenses"
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span v-text="header.text" />
          </template>
          <template v-slot:item.product="{ item }">
            <v-tooltip top>
              <template
                v-slot:activator="{ on }"
              >
                <div
                  class="py-2 text-wrap"
                  v-on="on"
                >
                  <v-chip
                    v-if="!item.product"
                    class="mt-3"
                    :class="'error'"
                    small
                    outlined
                  >
                    {{ $t("globals.no") }}
                  </v-chip>
                  <ApplicationPurchase
                    v-if="item.product"
                    :application="item.product"
                  />
                </div>
              </template>
              <b>{{ item.user && item.user.name }}</b>
              <br>
              <small>{{ item.user && item.user.email }}</small>
            </v-tooltip>
          </template>
          <template v-slot:item.account="{ item }">
            <span>
              {{ parseCustomValue(item.custom_values).broker_account_id }}<br>
            </span>
          </template>
          <template v-slot:item.key="{ item }">
            <div class="align-center text-wrap">
              <v-icon
                class="mr-2"
                @click="showLicenseKey(item.uuid)"
              >
                {{ showKey === item.uuid ? "mdi-eye" : "mdi-eye-off" }}
              </v-icon>
              <span>
                {{ showKey === item.uuid ? item.license_key : "#########" }}
              </span>
            </div>
          </template>
          <template v-slot:item.created_at="{ item }">
            <small>{{ item.created_at | moment("L") }}</small>
          </template>
          <template v-slot:item.expires_at="{ item }">
            <small>{{ item.expires_at ? (item.expires_at | moment("L")) : "-" }}</small>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu
              offset-y
              left
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  outlined
                  small
                  text
                  v-on="on"
                >
                  {{ $t('globals.manageButton') }}
                </v-btn>
              </template>
              <v-sheet dense>
                <v-list-item
                  @click="editLicenseKey(item)"
                >
                  <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="confirmDeleteLicense(item)"
                >
                  <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                </v-list-item>
              </v-sheet>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-flex
      v-else
      class="not-found"
    >
      <v-card>
        <v-icon>mdi-ghost</v-icon>
        <p>{{ $t("modules.licensesNotFound") }}</p>
      </v-card>
    </v-flex>
    <edit-request-status
      v-if="editKey"
      :show-dialog="editKey"
      :application="selectedLicense"
      :whitelabel-uuid="whitelabelUuid"
      edit-license
      @closeEditRequestDialog="closeEditLicenseDialog"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('modules.licensesReallyDelete', {name: selectedLicense.product.name})"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-layout>
</template>

<script>
import LICENSES_QUERY from "@/graphql/queries/modules/Licenses.gql";
import LICENSES_DELETE_MUTATION from "@/graphql/mutations/modules/LicenseDelete.gql";
import ApplicationPurchase from "@/views/Modules/Licenses/partial/Purchase.vue";
import EditRequestStatus from "@/views/Modules/Licenses/partial/EditRequestStatus.vue";
import { mapGetters } from "vuex";

export default {
  name: "LicenseView",
  components: {
    ApplicationPurchase,
    EditRequestStatus
  },
  props: {
    whitelabelUuid: {
      type: String,
      default: null,
    },
    search: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      totalLicenses: 0,
      confirmDialog: false,
      editKey: false,
      selectedLicense: null,
      params: {
        whitelabel_uuid: this.whitelabelUuid,
        page: 1,
        count: 5,
      },
      showKey: null,
      headers: [
        {
          sortable: false,
          text: this.$t("modules.applicationsPurchase"),
          value: "product",
          width: '40%',
        },
        {
          sortable: false,
          text: this.$t("modules.applicationsBrokerage"),
          value: "account",
        },
        {
          sortable: false,
          text: this.$t("modules.applicationsLicenseKey"),
          value: "key",
        },
        {
          sortable: false,
          text: this.$t("modules.applicationsAddedAt"),
          value: "created_at",
        },
        {
          sortable: false,
          text: this.$t("modules.applicationsExpirationdAt"),
          value: "expires_at",
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ],
    };
  },
  watch: {
    search() {
      this.reload();
    },
  },
  methods: {
    showLicenseKey(id) {
      if (this.showKey === id) {
        this.showKey = null;
      } else {
        this.showKey = id;
      }
    },
    editLicenseKey(item) {
      this.selectedLicense = item;
      this.editKey = true;
    },
    closeEditLicenseDialog(val) {
      this.editKey = false;
      this.selectedLicense = null;
      if (val) this.$apollo.queries.moduleLicenses.refetch();
    },
    confirmDeleteLicense(item) {
      this.confirmDialog = true;
      this.selectedLicense = item;
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteLicense()
      }
      this.selectedLicense = null
    },
    deleteLicense() {
      this.loading = true;
      let params = {
        whitelabel_uuid: this.whitelabelUuid,
        license_uuid: this.selectedLicense.uuid
      }
      this.$apollo
        .mutate({
          mutation: LICENSES_DELETE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.$apollo.queries.moduleLicenses.refetch()
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
    reload() {
      if (this.search) {
        if (this.search.length < 2) {
          return;
        }
        this.params.search = this.search;
      } else {
        delete this.params.search;
      }

      this.$apollo.queries.moduleLicenses.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
    },
    parseCustomValue(custom_values) {
      return JSON.parse(custom_values);
    },
    async loadLicenses({ page, itemsPerPage }) {
      this.loading = true;
      this.params.count = itemsPerPage;
      this.params.page = page;
      await this.$apollo.queries.moduleLicenses.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
      this.totalLicenses = this.moduleLicenses.total;
      this.loading = false;
    },
  },
  apollo: {
    moduleLicenses: {
      fetchPolicy: "network-only",
      query() {
        return LICENSES_QUERY;
      },
      variables() {
        return this.params;
      },
      skip() {
        return !this.params.whitelabel_uuid;
      },
    },
  },
};
</script>
